import { api } from "./api.ts";

export type WorkspaceState = {
  counts: Record<string, number>;
  facts: { key: string; value: unknown; tags: string[] }[];
  tasks: { id?: string; title: string; status: string; summary: string; facts: Record<string, unknown> }[];
  toolEvents: { toolName: string; success: boolean; latencyMs: number; args: any; result: any }[];
};

export function loadWorkspaceState(avatarId: string, signal?: AbortSignal): Promise<WorkspaceState> {
  return api<WorkspaceState>("/api/state", { avatarId, signal });
}
